import axios from "axios";
import { FETCH_ALL_CATEGORY_API } from "../Constants/Apis";

export const getCategorys = async () => {
  try {
    return axios.get(FETCH_ALL_CATEGORY_API);
  } catch (e) {
    return console.log(e);
  }
};

export const createCategory = async (payload) => {
  try {
    return axios.post(FETCH_ALL_CATEGORY_API, payload);
  } catch (e) {
    return console.log(e);
  }
};

export const updateCategory = async (id, payload) => {
  try {
    return axios.put(`${FETCH_ALL_CATEGORY_API}/${id}`, payload);
  } catch (e) {
    return console.log(e);
  }
};

export const deleteCategory = async (id) => {
  try {
    return axios.delete(`${FETCH_ALL_CATEGORY_API}/${id}`);
  } catch (e) {
    return console.log(e);
  }
};

